
import React, { useState, useEffect, memo, useMemo, useRef } from 'react';
import ValuesStore from '../../store/values-store';
import { useSearchParams, Link, useLocation, useNavigate } from 'react-router-dom';
import utils from '../../dependencies/custom/react-utilities';
import { Space, Table, Button, Input } from 'antd';
// import { Card, Input, Avatar, Dropdown, Button, Affix, Space, Modal, Empty, Badge, Menu } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import qs from 'qs';
import useTable from '../../hooks/table';
import useEdit from '../../hooks/edit';
import useAdd from '../../hooks/add';
import useDelete from '../../hooks/delete';
import Settings from '../../dependencies/custom/settings';


const AdminSettings = (props) => {
    const valuesStore = ValuesStore();
    const edit = useEdit('tables_metadata', 'table_name');//make this hook be aware of where to get tbl metadata 
    const add = useAdd('tables_metadata', 'table_name');
    const del = useDelete();
    const { filters, filterTypes } = utils.generateTableFilters();
    const navigate = useNavigate();
    //and key value that points to the table names from zustand store.    
    const table = useTable(
        {
            pagination: {
                current: 1,
                pageSize: 10,
            },
            filters: { ...filters },
            filterTypes: { ...filterTypes }
        },
        `${Settings.backend}/get_data`,
        'post',
        'result',
        'totalCount',
        'id',
        { prop: 'LIKE', value: 'LIKE' },
        { table: 'settings', fields: ['*'] });

    const columns = ([
        {
            title: 'Property',
            dataIndex: 'prop',
            ...table.getColumnSearchProps('prop'),
        },
        {
            title: 'Value',
            dataIndex: 'value',
            ...table.getColumnSearchProps('value'),
        },
        {
            title: 'Group',
            dataIndex: 'group_name',
            ...table.getColumnSearchProps('group_name'),
        },
        {
            title: 'Comment',
            dataIndex: 'comment',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => {
                return <Space size="middle">
                    <Button className='btn-success border-0' onClick={e => editRecord(record, 'settings')}><i className='fas fa-edit text-successx'/></Button>
                    {del.confirm(
                        `${Settings.backend}/delete`,
                        record,
                        'Are you sure to delete this item',
                        { tableName: 'settings', where: 'id', whereType: 'closed'},
                        <Button className='btn-danger border-0'><i className='fas fa-trash text-dangerx' /></Button>
                    )}                    
                </Space>
            },
        },
    ]);


    function editRecord(record, tableName) {
        const storeKey = 'editableRecord';
        valuesStore.setValue(storeKey, record);
        edit.setTblName(tableName);
        edit.setData(record);
        edit.setRecordKey(storeKey);
        edit.setShowModal(true);
        edit.setSaveCompleted(false);                
    }

    function addRecord(tableName = 'settings') {
        add.setTblName(tableName);
        add.setShowModal(true);
        add.setSaveCompleted(false);       
    }

    async function editOnOk() {
        let res = await edit.save(undefined, `${Settings.backend}/edit`, 'settings', { tbl: 'settings', where: 'id', whereType: 'closed' })        
    }

    async function addOnOk() {        
        let res = await add.save(`${Settings.backend}/add`, { tbl: 'settings' })
    }

    useMemo(() => {
        table.setColumns(columns);
        console.log('looping')        
        table.fetchData();
    }, [add.saveCompleted, edit.saveCompleted, del.saveCompleted]);


    return (
        <>
            {/* {console.log('render render')} */}
            <div className='container' /*style={{ marginTop: '4rem' }}*/>
                <div className='row'>
                    <div className='col-md-12 mb-2'>
                        <Button className='btn-primary border-0' onClick={e => addRecord()}><i className='fas fa-user-plus me-2' /> Add New Settings</Button>
                    </div>
                    <div className='col-md-12'>
                        <div className='table-responsive'>
                        {table.table}
                        </div>
                    </div>
                </div>
            </div>
            {edit.editModal('Edit Settings', editOnOk)}
            {add.addModal('Add New Settings', addOnOk)}
        </>
    );
}

export default memo(AdminSettings);